import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MessageIcon(props: IconProps) {
    return <Icon {...props} iconKey={"message"}/>
}
